module.exports = __webpack_public_path__ + "img/wuye.3315bf06.png";